import { render, staticRenderFns } from "./UcBillingListItemHeader.yaml?vue&type=template&id=497374d8&component"
import script from "./UcBillingListItemHeader.yaml?vue&type=script&lang=ts&component"
export * from "./UcBillingListItemHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports